import { Accordion } from '@mui/material';
import { BaseAccordionSectionProps } from './BaseAccordionSection.types';

export const BaseAccordionSection = ({
    classes,
    elevation,
    expanded,
    disabled,
    children,
}: BaseAccordionSectionProps) => {
    return (
        <Accordion
            classes={{
                ...classes,
            }}
            elevation={elevation}
            expanded={expanded}
            disabled={disabled}
        >
            {children}
        </Accordion>
    );
};